// src/components/AdminLayout.jsx
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import AdminSidebar from "./Sidebar";
import AdminTopbar from "./Topbar";
import "../styles/AdminLayout.css";
import UserDetail from "./UserDetail";

const AdminLayout = ({ children }) => {
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [role, setRole] = useState("");

  useEffect(() => {
    try {
      const token = localStorage.getItem("authToken");
      if (token) {
        const decoded = jwtDecode(token);
        setRole(decoded.role || "");
      }
    } catch {}
  }, []);

  const isAdmin = role === "admin";

  return (
    <div className={`admin-layout ${isAdmin ? "admin-layout--sidebar" : ""}`}>
      {isAdmin && (
        <>
          {sidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setSidebarOpen(false)}
            />
          )}
          <AdminSidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        </>
      )}

      <div className="main-content">
        <AdminTopbar
          onOpenUserDetails={() => setShowUserDetails(true)}
          onToggleSidebar={() => setSidebarOpen((p) => !p)}
          isAdmin={isAdmin}
        />
        <div className="content-body">
          {showUserDetails ? (
            <UserDetail onClose={() => setShowUserDetails(false)} />
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
